import { render, staticRenderFns } from "./PortalPages.vue?vue&type=template&id=79b0798d&"
import script from "./PortalPages.vue?vue&type=script&lang=js&"
export * from "./PortalPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports